import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig';
import { PrincipalListResp } from 'domain/payload/response/principal/PrincipalListResp';
import { PrincipalDetailResp } from 'domain/payload/response/principal/PrincipalDetailResp';
import { PrincipalCreateReq } from 'domain/payload/request/principal/PrincipalCreateReq';
import { PrincipalUpdateReq } from 'domain/payload/request/principal/PrincipalUpdateReq';

const PrincipalService = () => {
  const principalList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<PrincipalListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/principal/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const principalDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<PrincipalDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/principal/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const principalExportToCsv = async (token: string): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/report-engine/download?reportCode=PRINCIPAL_CSV_EXPORT&extension=csv`, {}, { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const principalCreate = async (
    token: string,
    request: PrincipalCreateReq
  ): Promise<BaseResponse<PrincipalDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/principal/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const principalUpdate = async (
    token: string,
    request: PrincipalUpdateReq
  ): Promise<BaseResponse<PrincipalDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/principal/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const uploadLogo = async (
    token: string,
    principalId: string,
    file: File
  ): Promise<BaseResponse<any>> => {
    try {
      const formData = new FormData();
      formData.append('principalId', principalId);
      formData.append('file', file);

      const response = await axiosInstance.post(`/v1/legacy/cms/principal/upload-logo`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const principalDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/principal/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  return { principalList, principalDetail, principalExportToCsv, principalCreate, principalUpdate, uploadLogo, principalDelete };
};

export default PrincipalService;
